export default __webpack_public_path__ + "static/media/hotel_4_hl.05d880e2.png";